exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.linked-icon[data-v-0dab70c7] {\n    position: relative;\n    top: -3px;\n}\n.icon-hidden[data-v-0dab70c7] {\n   color: transparent;\n}\n.edit-button[data-v-0dab70c7] {\n    font-size: 1em;\n}\n.link-button[data-v-0dab70c7] {\n    font-size: 1.2em;\n    position: relative;\n    top: 2px;\n}\n", ""]);

// exports
